import React from 'react';
import Breadcrumb from '../../breadcrumb';
import { HeaderTextBlockTitle } from '../../../styles/text-block/header-text-block';
import { Video } from '../../../helpers/video/index';
import { VideoCarousel } from '../../../styles/video-carousel';
import {
  SectionWrapper,
  InnerSectionWrapper,
  HeaderWrapper,
  HeaderTextBlockLeftAlign,
  HeaderTextBlockDescription,
  HeroVideoWrapper
} from './hero.styles';
import { useTopicContext } from '../context';
import { SendInViewEvent } from '../../../helpers/send-in-view-event';

export const Hero = () => {
  const { strapiTopic, isLoading } = useTopicContext() || {};
  const { topic_name, topic_url, topic_description, topic_videos } = strapiTopic || {};
  const [ref] = SendInViewEvent({ isLoading, component_name: 'topic_hero', data: strapiTopic });

  // TODO: add video ordering if exists
  const videos =
    topic_videos &&
    topic_videos.videos &&
    topic_videos.videos.filter((x) => x.youtube_id && x.youtube_id !== ' ');
  const videoCount = videos && videos.length;
  const hasCarousel = videoCount > 1;

  return (
    <SectionWrapper primary ref={ref}>
      <InnerSectionWrapper style={{ paddingBottom: '0' }}>
        <Breadcrumb name={topic_name} url={topic_url} />
      </InnerSectionWrapper>

      <InnerSectionWrapper hasCarousel={hasCarousel}>
        <HeaderWrapper videoCount={videoCount}>
          <HeaderTextBlockLeftAlign>
            <HeaderTextBlockTitle>{topic_name}</HeaderTextBlockTitle>
            <HeaderTextBlockDescription>{topic_description}</HeaderTextBlockDescription>
          </HeaderTextBlockLeftAlign>
        </HeaderWrapper>

        {videoCount > 0 && (
          <HeroVideoWrapper hasCarousel={hasCarousel}>
            {videos && videos.length === 1 && (
              <Video title={videos[0]?.video_name} youtubeId={videos[0]?.youtube_id} size="large" />
            )}

            {hasCarousel && <VideoCarousel videos={videos} showMoreLink={false} />}
          </HeroVideoWrapper>
        )}
      </InnerSectionWrapper>
    </SectionWrapper>
  );
};
